// UserFollowingGridCategory.jsx
import React from 'react';

import UniversalComponent from '../component/UniversalComponent.jsx';
import { reactRouterNoindexLoader } from '../resource/reactRouterNoindexLoader.js';

export const loader = reactRouterNoindexLoader;

const UserFollowingGridCategoryRoute = () => {
  return (
    <UniversalComponent
      filename="Container_FollowingUserGridList"
      importer={
        /* #__LOADABLE__ */ () =>
          import('../container/FollowingUserGridList.js')
      }
    />
  );
};

export default UserFollowingGridCategoryRoute;
